import { FastConditionalStrategy } from 'utility-ts-strategy';

export interface IAddPendingCourseError {
  field: string;
  value: Record<string, string>;
}

export const PendingCourseErrorMessageStrategy = new FastConditionalStrategy([
  [
    (error: IAddPendingCourseError) => 'Not a valid year',
    (error: IAddPendingCourseError) => error.field === 'term_year'
  ],
  [
    (error: IAddPendingCourseError) => `Course ${error.field} may not contain special characters`,
    (error: IAddPendingCourseError) => !!error.value.value_not_alphanumeric
  ],
  [
    (error: IAddPendingCourseError) =>
      "Course name may only contain the following special characters & , # . - ( ) ' / _",
    (error: IAddPendingCourseError) => !!error.value.value_not_valid_special_character
  ]
]);

angular
  .module('capability-ng-checklist')
  .constant('ngPendingCourseErrorMessageStrategy', PendingCourseErrorMessageStrategy);



// WEBPACK FOOTER //
// ./app/lib/transfer/strategies/pending_course_error_message_strategy.ts